module.exports = __webpack_public_path__ + "media/images/icons/photo-3d67c98c942022ffe4fd6f09dca6621b.svg";